import { MutableRefObject, useMemo } from 'react';

const useScrollContainer = (targetRef: MutableRefObject<HTMLElement>) => {
  const scrollContainer = useMemo(() => {
    let currentNode = targetRef?.current;
    while (currentNode && currentNode instanceof Element && currentNode !== document.body) {
      const { overflowY } = window.getComputedStyle(currentNode);
      if (overflowY === 'auto') {
        return { current: currentNode };
      }
      currentNode = currentNode.parentNode as HTMLDivElement;
    }
    return { current: document.body };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetRef?.current]);

  return scrollContainer;
};

export default useScrollContainer;
